import React from 'react';
import {Modal} from "react-bootstrap";
import logo_seizo_s from "../images/svg/logo_seizo_s.svg";
import logo_seizo_nom from "../images/svg/logo_seizo_nom.svg";

const Err403 = () => {
    return (
        <Modal show={true}
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               centered={true}
               backdrop="static"
               keyboard={false}
               dialogClassName={`w-50`}
               contentClassName={``}
               className={`modal-background`}
        >
            <Modal.Body className={"pb-5"}>
                <div
                    className={'mt-20 mb-20 w-full flex justify-center items-center text-center mx-auto'}>
                    <img src={logo_seizo_s} alt="Logo SEIZO" className={"h-16 w-16 align-text-bottom"}/>
                    <img src={logo_seizo_nom} alt="Logo SEIZO nom" className={"h-14"}/>
                </div>
                <h1 className={'title__connexion'}>Veuillez vérifier l'URL</h1>
                <div className={"border-none text-center"}>
                    Le code de votre espace est manquant
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default Err403;
